<div class="list-unstyled d-flex flex-row">
  <ng-container *ngFor="let progressOption of progressOptions; let i = index">
    <kt-task-action-button class="p-2" [progressOption]="progressOption"> </kt-task-action-button>
    <div *ngIf="i == 1" style="font-size: x-large; margin-top: 3px; color: #8080809c">|</div>
  </ng-container>

  <kt-task-filter-button
    class="p-2"
    [groupedByTeam]="groupedByTeam"
    [groupedByTemplate]="groupedByTemplate"
    [groupedByTag]="groupedByTag"
    [fromPatient]="fromPatient"
  ></kt-task-filter-button>
</div>
